import React, { FC, useEffect } from "react";
import RIGHTARROW from "../../../app/assets/images/dropdown-arrow.svg";
import { useNavigate } from "react-router-dom";
import { getPageData, useData } from "../../../app/helper/functions";

interface HeaderServiceDropDownProps {
  setDropdownVisible: (data: boolean) => void;
  headerRef: any;
  mode?: 'desktop' | 'mobile';
}

const HeaderServiceDropDown: FC<HeaderServiceDropDownProps> = ({
  setDropdownVisible,
  headerRef,
  mode = 'desktop',
}) => {
  const navigate = useNavigate();
  const { data } = useData();
  const homePageData = getPageData(data, "HomePageData");

  const handleClickOutside = (e: MouseEvent) => {
    if (headerRef.current && !headerRef.current.contains(e.target as Node)) {
      setDropdownVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (!homePageData || !homePageData.headerServicesList) return null;

  // Mobile: inline, no absolute, single column, compact
  if (mode === 'mobile') {
    return (
      <div className="py-2">
        {homePageData.headerServicesList.map((data: any, i: number) => (
          <div key={i} className="mb-4">
            <div className="flex gap-2 items-center pb-1.5">
              <img src={RIGHTARROW} className="w-4 h-4" alt="" />
              <span className="text-yellow text-base font-medium">{data.title}</span>
            </div>
            <ul className="space-y-2 list-disc list-inside pl-5">
              {data.value.map((val: any, j: number) => (
                <li
                  key={j}
                  className="text-sm text-white cursor-pointer hover:text-yellow hover:font-bold transition-all duration-200"
                  onClick={() => {
                    setDropdownVisible(false);
                    navigate(val.navigate);
                  }}
                >
                  {val.value}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    );
  }

  // Desktop: original absolute dropdown
  return (
    <div className="absolute right-[6%] top-[98%] my-4 z-10">
      <div className="grid grid-cols-3 gap-7 bg-black/50 backdrop-blur-sm p-5 pb-14" ref={headerRef}>
        {homePageData.headerServicesList.map((data: any, i: number) => (
          <div key={i} className="group">
            <div className="text-xl font-medium flex gap-2 items-center pb-2.5">
              <img src={RIGHTARROW} className="w-5 h-5" alt="RIGHTARROW" />
              <div className="w-full cursor-pointer text-yellow text-lg">
                {data.title}
              </div>
            </div>
            <ul className="block translate-y-4 space-y-2 transition-all duration-300 list-disc list-inside pl-5">
              {data.value.map((val: any, j: number) => (
                <li
                  key={j}
                  className="w-full text-lg cursor-pointer hover:text-yellow hover:font-bold transition-all duration-300"
                  onClick={() => {
                    setDropdownVisible(false);
                    navigate(val.navigate);
                  }}
                >
                  {val.value}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeaderServiceDropDown;